import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { oidcAuthModule } from './modules/oidcAuth';

export default createApp({
  features: [catalogPlugin, navModule, oidcAuthModule],
});
